$(() => {

    'use strict';

    /*============================================
        Initializations
    ==============================================*/

    // AJAX
    require('./modules/ajax.js');

    // Bootstrap
    require('./modules/bootstrap.js');

    /*============================================
        Event Listeners
    ==============================================*/

    // Unused links
    $(document).on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
    });

    // Preloader
    $(window).on('load', function () {
        $(window).trigger('scroll');
        $('body').attr('data-loaded', true);
    });

    setTimeout(() => {
        $('body').attr('data-loaded', true);
    }, 1500);

    // Navigations
    $('header').on('click', 'a[href^="#"]', function (e) {
        e.preventDefault();

        var target = $(this).attr('href'),
            position = $(target).offset().top,
            offset = target == '#hero' ? 100 : 50;

        $.scrollTo(position - offset);
    });
});
